
import { mapMutations, mapState } from 'vuex';

import Product from '@/components/shop/product.vue';
import LoadMore from '@/components/ui/loadMore.vue';
import Breadcrumbs from '@/components/shop/breadcrumbs.vue';

export default {
  name: 'TagPage',

  components: {
    Product,
    LoadMore,
    Breadcrumbs,
  },

  layout: 'cat',

  data() {
    return {
      page: 1,
      lastPage: null,
      perPage: 12,
      loading: false,
      visibleIds: [],
    };
  },

  computed: {
    ...mapState(['tags', 'products', 'patientId']),

    sortedProducts() {
      // eslint-disable-next-line
      return this.$store.getters.sortProducts(this.tagProducts);
    },

    visibleProducts() {
      return this.sortedProducts.filter((p) => this.visibleIds.includes(p.id));
    },

    tagName() {
      return this.$route.params.slug;
    },

    tag() {
      return this.tags.find((t) => t.slug === this.tagName);
    },

    tagProducts() {
      return this.products.filter((p) =>
        p.tags.map((t) => t.slug).some((t) => t.includes(this.tagName))
      );
    },
  },

  async mounted() {
    this.resetTagFilter();
    try {
      await this.getProducts();
    } catch (_) {
      return this.$nuxt.error({ statusCode: 404 });
    }
    this.$bolev.metaEvent({
      type: 'pageView',
      patientId: this.patientId,
    });
  },

  methods: {
    ...mapMutations(['setProducts', 'resetTagFilter']),

    async getProducts() {
      this.loading = true;
      const { data, headers } = await this.$wc.products({
        perPage: this.perPage,
        page: this.page,
        tag: this.tag.id,
      });
      this.loading = false;
      if (data && data.length) {
        this.visibleIds = [...this.visibleIds, ...data.map((p) => p.id)];
        this.visibleIds.filter(
          (value, index, array) =>
            array.findIndex((p) => p.id === value.id) === index
        );
        this.setProducts(data);
        if (headers['x-wp-totalpages']) {
          this.lastPage = parseInt(headers['x-wp-totalpages']);
          if (this.visibleProducts.length < 9 && this.lastPage > this.page) {
            this.getProducts();
          }
        }
        this.page++;
      }
    },
  },

  head() {
    if (this.tag) {
      return this.$seo.yoast(this.tag.yoast_head_json);
    }
  },
};
